module.exports = __webpack_public_path__ + "img/blue_096.610aba37.png";